import { create } from 'zustand';

import { WhoAmI } from 'shared/api/contracts';

export type LanguageCode = `ru-RU` | `en-EN` | `uz-UZ` | `kk-KK`;

interface AppStore {
	isLoading: boolean;
	setIsLoading: (loading: boolean) => void;
	currency?: string;
	setCurrency: (currency?: string) => void;
	user?: WhoAmI;
	setUser: (user?: WhoAmI) => void;
	isBlocked?: boolean;
	setIsBlocked: (isBlocked: boolean) => void;
}

export const useAppStore = create<AppStore>()(set => ({
	isLoading: false,
	setIsLoading: (isLoading: boolean) => set({ isLoading }),
	currency: undefined,
	setCurrency: (currency?: string) => set({ currency }),
	user: undefined,
	setUser: (user?: WhoAmI) => set({ user }),
	isBlocked: false,
	setIsBlocked: (isBlocked: boolean) => set({ isBlocked }),
}));
